import { Grid, Typography, Chip, useMediaQuery } from "@mui/material";
import { ArrayField, Datagrid, DateField, FunctionField, useNotify } from "react-admin";
import { settings } from "app";
import { getFile } from "server/components/DownloadFile";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import UploadFinalExamProtocolDialog from "./components/UploadFinalExamProtocolDialog";
import { SectionTitle } from "features/SectionTitle";

const FinalExamSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const notify = useNotify();

  return (
    <>
      <SectionTitle
        title="Финален изпит"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <ArrayField source="finalExamProtocols">
            <Datagrid
              bulkActionButtons={false}
              rowClick={false}
              sx={[settings.style.detailsDatagrid, { "& .RaDatagrid-headerCell": { textAlign: "left" } }]}
            >
              <FunctionField
                label="Резултат"
                sortable={false}
                render={protocol =>
                  protocol.isPassed ? (
                    <Chip
                      label="Издържан"
                      color="success"
                      size="small"
                    />
                  ) : (
                    <Chip
                      label="Неиздържан"
                      color="error"
                      size="small"
                    />
                  )
                }
              />
              <FunctionField
                label="Протокол"
                render={protocol =>
                  protocol.protocolDocumentId ? (
                    <Typography
                      sx={{
                        textDecoration: "underline",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                      onClick={() => getFile(protocol.protocolDocumentId, notify, "private")}
                    >
                      Изтегли
                    </Typography>
                  ) : (
                    "-"
                  )
                }
              />
              <DateField
                source="createdOn"
                label="Създаден на"
                locales="bg-BG"
                showTime
                sortable={false}
              />
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid
          item
          xs={12}
        >
          <SecuredComponent permission={permissions.canManageAdvancedSpecializationSpecialists}>
            <FunctionField
              render={rec => (
                <UploadFinalExamProtocolDialog
                  id={rec?.id}
                  fullyCoversStudyDuration={rec?.fullyCoversStudyDuration}
                  statusId={rec?.statusId}
                />
              )}
            />
          </SecuredComponent>
        </Grid>
      </Grid>
    </>
  );
};

export default FinalExamSection;
